import { DeviceOs } from '@system/device-detector'

export enum DialogType {
  Contact = 'contact',
  Download = 'download',
}

export interface DownloadItem {
  os: DeviceOs
  type: string
  text: string
  url: string | object
}
